import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../redux/reducers';
export default function configureStore(initialState?: any) {
    const domain = process.env.REACT_APP_DOMAIN || ".learnship.today";
    const env = domain.split(".")[2].trim().toLowerCase();

    return createStore(
        rootReducer,
        initialState,
        compose(
            applyMiddleware(thunk),
            env === "tech" && (window as any).__REDUX_DEVTOOLS_EXTENSION__ ? (window as any).__REDUX_DEVTOOLS_EXTENSION__() : compose
        )        
    );
}